import React from "react";

export const Pending = () => {
  return (
    <div>
      {" "}
      <div className="carrito">
        <h1 className="title">
          To compra ha ha quedado en Stand-By. Ingresa a MercadoPago para
          concretar el pago.{" "}
        </h1>
      </div>
    </div>
  );
};
